import { useEffect } from "react";

/**
 * Hides the Crisp chat bubble while the calling component is mounted.
 * Restores the bubble on unmount so authenticated pages still see it.
 */
export function useHideCrisp() {
  useEffect(() => {
    if (typeof window === "undefined" || !window.$crisp || typeof window.$crisp.push !== "function") return;
    window.$crisp.push(["do", "chat:hide"]);
    return () => {
      if (typeof window === "undefined" || !window.$crisp || typeof window.$crisp.push !== "function") return;
      window.$crisp.push(["do", "chat:show"]);
    };
  }, []);
}
